import React, { Component } from "react";
import { Components } from "@webtech/webtech-ui-react/build/webtech-ui";
import { connect } from "react-redux";

import "./PasswordCard.component.scss";
import PasswordForm from "./PasswordForm/PasswordForm.component";
import { ActionCreator } from "../../../../../actions/actions";
import { AuthActionCreators } from "../../../actions/actionCreators";

export interface PasswordCardProps {
    newPassword: ActionCreator;
}

class PasswordCard extends Component<PasswordCardProps, {}> {
    render() {
        return (
            <div id="PasswordCard">
                <div>
                    <div className="title-1">Welcome back</div>
                    <div className="title-2">Please enter your new password</div>
                    <PasswordForm onSubmit={this.props.newPassword} />
                </div>
            </div>
        );
    }
}

const mapDispatchToProps = {
    newPassword: AuthActionCreators.new_password
};

export default connect(
    null,
    mapDispatchToProps
)(PasswordCard);
